import { useCallback, useEffect, useState } from "react";

import EmptyState from "../components/EmptyState";
import PageTitle from "../components/PageTitle";
import { adminApi, buildQuery } from "../services/adminApi";
import { getResults } from "../utils/formatters";

const cateringStatuses = [
  "new",
  "contacted",
  "quoted",
  "accepted",
  "declined",
  "cancelled",
  "completed",
];

export default function CateringPage({ filters }) {
  const [requests, setRequests] = useState([]);

  const loadRequests = useCallback(async () => {
    const payload = await adminApi(`/catering-requests/${buildQuery(filters)}`);
    setRequests(getResults(payload));
  }, [filters]);

  useEffect(() => {
    loadRequests().catch(console.error);
  }, [loadRequests]);

  const updateStatus = async (requestId, status) => {
    await adminApi(`/catering-requests/${requestId}/`, {
      method: "PATCH",
      body: JSON.stringify({ status }),
    });
    await loadRequests();
  };

  return (
    <main className="admin-page flex flex-column gap-5">
      <PageTitle eyebrow="Catering" title="Catering Requests">
        Track contact, quote state, deposits, and request status.
      </PageTitle>

      <section className="card admin-panel">
        <header className="card-header">
          <h2>Requests</h2>
        </header>
        <div className="card-body">
          {!requests.length ? <EmptyState /> : null}

          {requests.length ? (
            <div className="admin-list">
              {requests.map((request) => (
                <article key={request.id}>
                  <strong>{request.customer_name}</strong>
                  <span>
                    {request.event_type} - {request.event_date} - {request.guest_count} guests
                  </span>
                  <span>
                    {request.preferred_location_name} - Quote: {request.quote_status || "not started"}
                  </span>
                  <select
                    value={request.status}
                    onChange={(event) => updateStatus(request.id, event.target.value)}
                  >
                    {cateringStatuses.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                </article>
              ))}
            </div>
          ) : null}
        </div>
      </section>
    </main>
  );
}